<script setup lang="ts"></script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="origin-center transition-colors duration-300 ease-in-out"
  >
    <path
      d="M7 17L17 7M17 7H7M17 7V17"
      class="transition-colors duration-300 ease-in-out"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
